// import Routes from "./routes";
import React, { lazy, Suspense, useEffect } from "react";
import "./App.css";
import { MuiThemeProvider } from "@material-ui/core";
import Loader from "./components/Dashboard/CommonComponents/Loader";
import { BrandingProvider, useBranding } from "./contexts/BrandingContext";

const Routes = lazy(() => import("./routes"));


// src/App.js
const AppContent = () => {
  const { loading, error, branding, theme } = useBranding();

  useEffect(() => {
    if (branding) {
      document.title = branding.appTitle;
      let favicon = document.querySelector("link[rel='shortcut icon']") || document.querySelector("link[rel='icon']");
      if (!favicon) {
        favicon = document.createElement('link');
        favicon.setAttribute('rel', 'shortcut icon');
        document.head.appendChild(favicon);
      }
      favicon.setAttribute('href', branding.faviconPath);
    }
  }, [branding]);

  if (loading) return <Loader />;
  if (error) return <div>Error loading branding: {error}</div>;

  return (
    <MuiThemeProvider theme={theme}>
      <Suspense fallback={<Loader />}>
        <Routes />
      </Suspense>
    </MuiThemeProvider>
  );
};
const App = () => {
  return (
    <BrandingProvider>
      <AppContent />
    </BrandingProvider>
  );
};

export default App;
